import { FC, ReactNode } from 'react';
import { Box, CircularProgress, Portal, Typography } from '@mui/material';

import { theme } from '@mopla/mui';

import {
	FullScreenLoaderWrapper,
	LoaderWrapper,
} from './PaymentLoadingOverlay.styles';

interface IProps {
	text: string;
	children?: ReactNode;
	testId?: string;
	/** Render in a Portal, fixed over the whole viewport and above page UI. */
	fullScreen?: boolean;
}

export const PaymentLoadingOverlay: FC<IProps> = ({
	text,
	children,
	testId,
	fullScreen = false,
}) => {
	const Wrapper = fullScreen ? FullScreenLoaderWrapper : LoaderWrapper;
	const overlay = (
		<Wrapper data-testid={testId}>
			<Box display="flex" flexDirection="column" alignItems="center">
				<CircularProgress style={{ color: theme.palette.neutral[0] }} />
				<Typography
					sx={{
						marginTop: '8px',
						color: theme.palette.primary.contrastText,
					}}
					variant="bodyTitle"
				>
					{text}
				</Typography>
				{children}
			</Box>
		</Wrapper>
	);

	return fullScreen ? <Portal>{overlay}</Portal> : overlay;
};
